<template>
    <section id="content-company-info">
        <h2>Company Information</h2>

        <!-- <div class="info-card">
        <div class="info-item-group list">
            <img src="./assets/broker-dealer.svg" />
            <label>Broker-Dealer</label>
            <span>{{ brokerDealer }}</span>
        </div>

        <div class="info-item-group list">
            <img src="./assets/custodians.svg" />
            <label>Custodians</label>
            <div>
            <template v-for="custodian in (custodians || '').split(',')">
                <span :key='custodian'>{{ custodian }}<br></span>
            </template>
            </div>
        </div>

        <div class="info-item-group list">
            <img src="./assets/tamps.svg" />
            <label>TAMPS</label>
            <span>{{ tamps }}</span>
        </div>
        </div> -->

        <div class="d-flex pa-3 mt-2 mb-9 justify-center association_box">
            <div v-if="!insuranceBasedListings.includes(practiceType)" class="d-inline text-center align-start" style="width: 33%">
                <img src="./assets/broker-dealer.svg" class="d-block" style="margin:0 auto" />
                <span class="d-block sansation font-weight-black grow--text association_title">Broker-Dealer</span>
                <label class="d-block">{{ brokerDealer }}</label>
            </div>

            <div v-if="!insuranceBasedListings.includes(practiceType)" class="d-inline text-center align-start" style="width: 34%">
                <img src="./assets/custodians.svg" class="d-block" style="margin:0 auto" />
                <span class="d-block sansation font-weight-black grow--text association_title">Custodians</span>
                <template v-for="custodian in (custodians || 'None').split(';')">
                <label class="d-block" :key='custodian'>{{ custodian }}<br></label>
                </template>
            </div>

            <div v-if="!insuranceBasedListings.includes(practiceType)" class="d-inline text-center align-start" style="width: 33%">
                <img src="./assets/tamps.svg" class="d-block" style="margin:0 auto" />
                <span class="d-block sansation font-weight-black grow--text association_title">TAMPS</span>
                <template class="d-block" v-for="tamp in (tamps || 'None').split(';')">
                <label :key='tamp'>{{ tamp }}<br></label>
                </template>
            </div>

            <div v-if="insuranceBasedListings.includes(practiceType)" class="d-flex text-center align-start py-3" style="width: 100%">
                <div class="d-inline mr-5 text-right" style="width: 20%">
                    <img src="./assets/life-jacket.svg" style="width: 35%" />
                </div>
                <div class="d-inline text-left">
                    <span class="d-block sansation font-weight-black grow--text association_title"> Insurance Carriers & Percentage of Revenue:</span>
                        <template class="d-block" v-for="carrier in (insuranceCarriers || '').split(';')">
                    <label :key='carrier'>{{ carrier }}<br></label>
                    </template>
                </div>
            </div>
        </div>

        <div class="info-grid tiles">
            <div v-if="households" class="info-item-group">
                <img src="./assets/house.svg" />
                <span class="number_size">{{ households }}</span>
                <label>{{ householdLabel }}</label>
            </div>

            <div v-if="clientAge" class="info-item-group">
                <img src="./assets/plant.svg" />
                <span class="number_size">{{ clientAge }}</span>
                <label>Average Client Age</label>
            </div>

            <div v-if="clientsLocal" class="info-item-group">
                <img src="./assets/map.svg" />
                <span class="number_size">{{ clientsLocal }}%</span>
                <label>Local Clients</label>
            </div>

            <div v-if="householdsHighAum" class="info-item-group">
                <img src="./assets/coins.svg" />
                <span class="number_size">{{ householdsHighAum }}</span>
                <label>{{ householdHighAumLabel }} with 1M+ in AUM</label>
            </div>

            <div v-if="clientTenure" class="info-item-group">
                <img src="./assets/clock.svg" />
                <span class="number_size">{{ clientTenure }}</span>
                <label>{{ tenureLabel }}</label>
            </div>

            <div class="info-item-group list">
                <img src="./assets/multi-gen.svg" />
                <label class="small">Multi-Generational Planning</label>
                <span>{{ hasMultigenPlanning ? 'Yes' : 'No' }}</span>
            </div>

            <div v-if="clientAcquisitionMethods" class="info-item-group list d-flex" :class="(clientAcquisitionMethods || '').split(',').length > 1 ? 'align-start' : 'align-center'">
                <img src="./assets/network.svg" class="d-inline" />
                <div class="d-inline">
                    <label class="d-block small">Key Method for Client Acquisition</label>
                    <template v-for="method in (clientAcquisitionMethods || '').split(',')">
                        <span :key="method" class="d-block">{{ method }}</span>
                    </template>
                </div>
            </div>

            <div v-if="showEmptyCell" class="info-item-group empty"></div>
        </div>
    </section>
</template>

<script>
    export default {
        name: 'DetailsCompanyInformation',

        props: {
            insuranceBasedListings: {
                type: Array,
                default: []
            },
            practiceType: {
                type: Number,
                default: 1,
            },
            brokerDealer: {
                type: String,
                default: 'None',
            },
            custodians: {
                type: String,
                default: 'None',
            },
            tamps: {
                type: String,
                default: 'None',
            },
            insuranceCarriers: {
                type: String,
                default: ''
            },
            households: {
                type: String,
                default: '0',
            },
            clientsLocal: {
                type: String,
                default: '0',
            },
            clientTenure: {
                type: String,
                default: '1',
            },
            clientAcquisitionMethods: {
                type: String,
                default: 'N/A',
            },
            clientAge: {
                type: String,
                default: '1',
            },
            householdsHighAum: {
                type: String,
                default: '0',
            },
            hasMultigenPlanning: {
                type: Boolean,
                default: false,
            }
        },

        computed: {
            householdLabel () {
                const num = Number(this.households)
                const base_word = this.insuranceBasedListings.includes(this.practiceType) ? 'Client' : 'Household'
                return `${base_word}${num === 1 ? '' : 's'}`
            },

            householdHighAumLabel () {
                const num = Number(this.householdsHighAum)
                return `Household${num === 1 ? '' : 's'}`
            },

            tenureLabel () {
                const num = Number(this.clientTenure)
                return `Year${num === 1 ? '' : 's'} Avg Client Tenure`
            },
          
            showEmptyCell () {
                let num = 0;
                if (this.households != null) num++
                if (this.clientsLocal != null) num++
                if (this.clientTenure != null) num++
                if (this.clientAcquisitionMethods != null) num++
                if (this.clientAge != null) num++
                if (this.householdsHighAum != null) num++
                if (this.hasMultigenPlanning != null) num++

                return num % 2 == 0 ? false : true;
            },
        },
    }
</script>

<style scoped>
.info-card {
  border-color: #97c131;
}

.association_title {
  font-size: 1.1rem !important
}
.association_box {
  width: 100%; 
  border:2px dashed #97C131;
}

.number_size {
  font-size: 1.2rem
}
</style>



// WEBPACK FOOTER //
// src/components/buyer-listing-details/full-details-content/CompanyInformation.vue